var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.316406C2.46265 0.316406 0 2.77994 0 5.81641C0 8.85465 2.46265 11.3164 5.5 11.3164C8.53735 11.3164 11 8.85465 11 5.81641C11 2.77994 8.53735 0.316406 5.5 0.316406ZM5.5 2.75592C6.01443 2.75592 6.43145 3.17295 6.43145 3.68737C6.43145 4.2018 6.01443 4.61883 5.5 4.61883C4.98557 4.61883 4.56855 4.2018 4.56855 3.68737C4.56855 3.17295 4.98557 2.75592 5.5 2.75592ZM6.74194 8.38899C6.74194 8.53596 6.62278 8.65512 6.47581 8.65512H4.52419C4.37722 8.65512 4.25806 8.53596 4.25806 8.38899V7.85673C4.25806 7.70976 4.37722 7.5906 4.52419 7.5906H4.79032V6.17124H4.52419C4.37722 6.17124 4.25806 6.05209 4.25806 5.90512V5.37286C4.25806 5.22589 4.37722 5.10673 4.52419 5.10673H5.94355C6.09052 5.10673 6.20968 5.22589 6.20968 5.37286V7.5906H6.47581C6.62278 7.5906 6.74194 7.70976 6.74194 7.85673V8.38899Z",
    fill: "#01B544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSuccess);
export default __webpack_public_path__ + "static/media/info-success.4a836c0ed10207b10d5fc154b31b2842.svg";
export { ForwardRef as ReactComponent };